import React, {useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import {login} from '../../_redux/authActions';
import {useFormik} from 'formik';
import classnames from "classnames";
import * as Yup from 'yup';
import {FormattedMessage, injectIntl} from 'react-intl';
import * as auth from '../../_redux/authRedux';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {images as I} from '../../constants/images';
import ButtonAction from '../../../_common/components/ButtonAction';
import CommonGridSpinner from '../../../_common/components/CommonGridSpinner';
import {StyledFieldInput} from '../../../_common/components/FieldInput';
import {buttonSubmit} from '../../../_common/styles/styles';
import styles from './styles.module.scss';

const initialValues = {
  username: '',
  password: ''
};

export function AuthPage(props) {
  const history = useHistory();
  const location = useLocation();
  if (location.pathname !== '/') history.replace('/');

  const {intl} = props;
  const usernamePlaceholder = intl.formatMessage({id: 'auth-username-label'});
  const passwordPlaceholder = intl.formatMessage({id: 'auth-password-label'});

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const LoginSchema = Yup.object().shape({
    username: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        })
      ),
    password: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        })
      ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setStatus(undefined);
      enableLoading();
      setTimeout(() => {
        Promise
          .resolve()
          .then(() => {
            const {username, password} = values;
            return dispatch(login({username, password}));
          })
          .then(() => {
            disableLoading();
          })
          .catch(() => {
            disableLoading();
            setSubmitting(false);
            setStatus(
              intl.formatMessage({
                id: 'AUTH.VALIDATION.INVALID_LOGIN',
              })
            );
          });
      }, 1000);
    },
  });

  return (
    <div
      className="login login-5 login-signin-on d-flex flex-row-fluid"
      id="kt_login"
    >
      <div
        className={`d-flex justify-content-center align-items-center bgi-size-cover bgi-no-repeat flex-row-fluid ${styles.background}`}
        style={{backgroundImage: `url(${I.BG})`}}
      >
        <div className={styles.loginForm}>
          <div className={styles.logo}>
            <img src={toAbsoluteUrl(I.LOGO)} alt="logo"/>
          </div>
          <div className={'w-100 px-12'}>
            <div className="my-10">
              <h2 className="font-weight-normal text-dark text-center">
                <FormattedMessage id="AUTH.LOGIN.TITLE"/>
              </h2>
              <h4 className="font-weight-normal text-dark text-center">
                <FormattedMessage id="auth-form-title"/>
              </h4>
            </div>
            <form
              className="form"
              id="kt_login_signin_form"
              onSubmit={formik.handleSubmit}
            >
              <StyledFieldInput
                fieldId={'username'}
                autoComplete="off"
                placeholder={usernamePlaceholder}
                {...formik.getFieldProps('username')}
                customContainerStyles={'mb-12'}
                icon={'/media/common/User_primary.svg'}
              />
              <StyledFieldInput
                fieldId={'password'}
                type={'password'}
                placeholder={passwordPlaceholder}
                {...formik.getFieldProps('password')}
                customContainerStyles={'mb-12'}
                icon={'/media/common/Lock_primary.svg'}
              />
              <div className="mt-20 mb-12 text-center position-relative">
                <ButtonAction
                  id="kt_login_signin_submit"
                  type="submit"
                  useIcon="/media/common/Login_white.svg"
                  label={<FormattedMessage id="auth-login-btn" defaultMessage="Sign in"/>}
                  customClassnames={buttonSubmit}
                />
                {loading && <CommonGridSpinner customClassnames={styles.spinnerContainer}/>}
                {!loading && <div className={classnames('text-danger', styles.spinnerContainer)}>{formik.status}</div>}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

const connectedAuthPage = connect(null, auth.actions)(AuthPage);
export default injectIntl(connectedAuthPage);
